
const NS = 'LengthGreaterThan'; // jshint ignore:line

export default function LengthGreaterThan() { // as lengthGreaterThan
  "ngInject";

  return {
    require: 'ngModel',
    link,
    restrict: 'A'
  };

  function link(scope, element, attrs, ngModel) {

    var validate = function(viewValue) {
      var numGreaterThan = Number(attrs.lengthGreaterThan);
      if (!ngModel.$modelValue || !ngModel.$viewValue || !numGreaterThan) {
        // It's valid because we have nothing to compare against
        ngModel.$setValidity('length-greater-than', true);
      } else {
        var total = ngModel.$viewValue.length;
        // It's valid if model is lower than the model we're comparing against
        var valid = (total >= numGreaterThan) ? true : false;
        ngModel.$setValidity('length-greater-than', valid);
      }
      return viewValue;
    };
    ngModel.$parsers.unshift(validate);
    ngModel.$formatters.push(validate);

    attrs.$observe('lengthGreaterThan', function() {
      // Whenever the comparison model changes we'll re-validate
      return validate(ngModel.$viewValue);
    });
  }

}
